var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListItemCheckbox',{staticClass:"align-center",attrs:{"disabled":_vm.isSavingJobAssets,"value":_vm.value === 'Yes' || _vm.value === true,"color":"blue","hide-details":""},on:{"change":function($event){return _vm.$emit('update', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }